import {
  AccessTokenResponseDto,
  AuthApiAuthControllerForgotPasswordRequest,
  AuthApiAuthControllerLoginRequest,
  AuthApiAuthControllerResetPasswordRequest,
  AuthApiAuthControllerSignupRequest,
} from '@givz/core-client';
import { useCoreClientMutation, UseCoreClientMutationParams } from './client';

export const useLogin = (
  params?: Partial<
    UseCoreClientMutationParams<
      AccessTokenResponseDto,
      unknown,
      AuthApiAuthControllerLoginRequest
    >
  >,
) => {
  return useCoreClientMutation({
    ...params,
    mutationFn: (client) => client.Auth.login,
  });
};

export const useSignUp = (
  params?: Partial<
    UseCoreClientMutationParams<
      AccessTokenResponseDto,
      unknown,
      AuthApiAuthControllerSignupRequest
    >
  >,
) => {
  return useCoreClientMutation({
    ...params,
    mutationFn: (client) => client.Auth.signup,
  });
};

export const useForgotPassword = (
  params?: Partial<
    UseCoreClientMutationParams<
      void,
      unknown,
      AuthApiAuthControllerForgotPasswordRequest
    >
  >,
) => {
  return useCoreClientMutation({
    ...params,
    mutationFn: (client) => client.Auth.forgotPassword,
  });
};

export const useResetPassword = (
  params?: Partial<
    UseCoreClientMutationParams<
      void,
      unknown,
      AuthApiAuthControllerResetPasswordRequest
    >
  >,
) => {
  return useCoreClientMutation({
    ...params,
    mutationFn: (client) => client.Auth.resetPassword,
  });
};
